import styled from 'styled-components';
import { color, typography } from 'styles/settings';
import { normalize } from 'utils';

export const ErrorComponent = styled.div`
  border-radius: ${normalize(5)};
  color: ${color.ui.danger};
  font-size: ${typography.size.xs};
  ${typography.font.medium};
  padding-top: ${normalize('5px')};
`;
